import $ from 'jquery';
import { readHubId, writeHubId } from './hub-url';

(function () {
  const overlayClass = 'energy-insights__overlay';
  let active = null;

  function getOverlay(grid) {
    const context = grid.closest('.home--energy-insights, .energy-insights-page') || document.body;
    let overlay = Array.prototype.slice.call(context.children).find((child) => {
      return child.classList && child.classList.contains(overlayClass);
    });

    if (!overlay) {
      overlay = document.querySelector(`.${overlayClass}`) || document.createElement('button');

      if (!overlay.classList.contains(overlayClass)) {
        overlay.type = 'button';
        overlay.className = overlayClass;
        overlay.setAttribute('aria-label', 'Close energy insight');
      }

      context.appendChild(overlay);
    }

    return overlay;
  }

  function getCardColumns(grid) {
    return Array.prototype.slice.call(
      grid.querySelectorAll('[data-energy-insight-card-col]')
    ).filter((column) => {
      return column.parentNode === grid && column.offsetParent !== null;
    });
  }

  function moveDetailAfterSelectedRow(grid, selectedColumn, detail) {
    const selectedTop = selectedColumn.offsetTop;
    const rowColumns = getCardColumns(grid).filter((column) => {
      return Math.abs(column.offsetTop - selectedTop) < 8;
    });
    const lastColumn = rowColumns[rowColumns.length - 1] || selectedColumn;

    lastColumn.insertAdjacentElement('afterend', detail);
  }

  function setTriggerLabel(trigger, label) {
    if (!trigger || !label) {
      return;
    }

    trigger.textContent = label;
  }

  function scrollCardToTop(selectedColumn) {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? 'auto'
      : 'smooth';
    const top = selectedColumn.getBoundingClientRect().top + window.pageYOffset;

    window.requestAnimationFrame(() => {
      window.scrollTo({
        top,
        behavior
      });
    });
  }

  function openDetail(trigger, updateUrl = true) {
    const id = trigger.getAttribute('data-energy-insight-trigger');
    const grid = trigger.closest('.energy-insights__cards');
    const selectedColumn = trigger.closest('[data-energy-insight-card-col]');
    const card = trigger.closest('.energy-insights__card');
    const detail = grid ? grid.querySelector(`[data-energy-insight-detail="${id}"]`) : null;

    if (!grid || !selectedColumn || !card || !detail) {
      return;
    }

    if (active && active.id === id) {
      closeDetail();
      return;
    }

    closeDetail(false, false);
    moveDetailAfterSelectedRow(grid, selectedColumn, detail);

    const overlay = getOverlay(grid);
    overlay.classList.add('is-active');
    overlay.addEventListener('click', closeDetail);

    detail.hidden = false;
    detail.style.height = '0px';
    detail.classList.add('is-open');
    card.classList.add('is-selected');
    trigger.setAttribute('aria-expanded', 'true');

    const triggerLabel = trigger.textContent.trim();
    setTriggerLabel(trigger, 'Close');

    active = {
      id,
      card,
      detail,
      grid,
      selectedColumn,
      trigger,
      triggerLabel,
      overlay
    };

    if (updateUrl) writeHubId('insight', id);
    scrollCardToTop(selectedColumn);

    window.requestAnimationFrame(() => {
      if (active && active.detail === detail) {
        detail.style.height = `${detail.scrollHeight}px`;
      }
    });

    window.setTimeout(() => {
      if (active && active.detail === detail) {
        detail.style.height = 'auto';
      }
    }, 360);
  }

  function closeDetail(animate = true, updateUrl = true) {
    if (!active) {
      return;
    }

    const { card, detail, trigger, triggerLabel, overlay } = active;
    active = null;
    if (updateUrl) writeHubId('insight', null);

    card.classList.remove('is-selected');
    trigger.setAttribute('aria-expanded', 'false');
    setTriggerLabel(trigger, triggerLabel);
    overlay.classList.remove('is-active');
    overlay.removeEventListener('click', closeDetail);

    const finish = () => {
      detail.removeEventListener('transitionend', finish);
      if (active && active.detail === detail) return;
      detail.hidden = true;
      detail.classList.remove('is-open');
      detail.style.height = '';
      detail.removeEventListener('transitionend', finish);
    };

    if (!animate) {
      finish();
      return;
    }

    detail.style.height = `${detail.scrollHeight}px`;

    window.requestAnimationFrame(() => {
      if (!active || active.detail !== detail) detail.style.height = '0px';
    });

    detail.addEventListener('transitionend', finish);
    // transitionend may not fire with reduced motion or an unchanged height.
    window.setTimeout(finish, 400);
  }

  function repositionActiveDetail() {
    if (!active) {
      return;
    }

    moveDetailAfterSelectedRow(active.grid, active.selectedColumn, active.detail);
  }

  async function copyUrl(button) {
    const url = button.getAttribute('data-copy-url');
    const label = button.querySelector('[data-energy-insight-copy-label]');
    const originalLabel = label ? label.textContent : '';

    if (!url) {
      return;
    }

    const fallbackCopy = () => {
      const input = document.createElement('textarea');
      input.value = url;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        if (!document.execCommand('copy')) throw new Error('Copy failed');
      } finally {
        input.remove();
        button.focus();
      }
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        try {
          await navigator.clipboard.writeText(url);
        } catch (error) {
          fallbackCopy();
        }
      } else {
        fallbackCopy();
      }
    } catch (error) {
      if (label) label.textContent = 'Unable to copy — try again';
      return;
    }

    button.classList.add('is-copied');

    if (label) {
      label.textContent = 'Copied';
    }

    window.setTimeout(() => {
      button.classList.remove('is-copied');

      if (label) {
        label.textContent = originalLabel || 'Copy url';
      }
    }, 1600);
  }

  function showCategoryLoading(select) {
    const page = select.closest('.energy-insights-page');
    const cards = page ? page.querySelector('.energy-insights__cards') : null;
    const url = select.value;

    if (!cards || !url || url === window.location.href.split('#')[0]) {
      return;
    }

    cards.classList.add('is-loading');
  }

  function syncInsightUrl() {
    const legacy = window.location.hash.match(/^#energy-insight-([1-9][0-9]*)$/);
    const id = readHubId('insight') || (legacy ? legacy[1] : null);
    const trigger = id ? document.querySelector(`[data-energy-insight-trigger="${id}"]`) : null;
    if (!trigger) {
      if (legacy && !new URL(window.location.href).searchParams.has('insight')) {
        const url = new URL(window.location.href);
        url.searchParams.set('insight', id);
        url.hash = '';
        window.location.replace(url.href);
        return;
      }
      closeDetail(false, false);
      if (new URL(window.location.href).searchParams.has('insight') || legacy) {
        writeHubId('insight', null, true);
      }
      return;
    }
    if (legacy) writeHubId('insight', id, true);
    if (!active || active.id !== id) openDetail(trigger, false);
  }

  $(document).on('click', '[data-energy-insight-trigger]', function () {
    openDetail(this);
  });

  $(document).on('click', '[data-energy-insight-close]', function () {
    closeDetail();
  });

  $(document).on('click', '[data-energy-insight-copy-url]', function () {
    copyUrl(this);
  });

  $(document).on('change', '.energy-insights-page .newsroom-filter-select', function () {
    showCategoryLoading(this);
  });

  $(document).on('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDetail();
    }
  });

  $(window).on('resize', repositionActiveDetail);
  $(window).on('popstate hashchange', syncInsightUrl);

  $(syncInsightUrl);
})();
